export function clearNumber(input) {
  const str = String(input);
  const digitsAndDots = str.replace(/[^0-9.]/g, '');
  const firstDotIndex = digitsAndDots.indexOf('.');

  if (firstDotIndex === -1) return digitsAndDots;

  const beforeDot = digitsAndDots.slice(0, firstDotIndex + 1);
  const afterDot = digitsAndDots.slice(firstDotIndex + 1).replace(/\./g, '');

  return beforeDot + afterDot;
}
